<div class="modal-header destructive">
  <h4 class="modal-title">{{ data.title }}</h4>
</div>

<div class="modal-body" role="alertdialog" aria-modal="true">
  <p class="destructive__description">{{ data.description }}</p>

  <div class="destructive__metrics">
    <div class="metric">
      <div class="metric__label">
        {{ 'pages.stock.bulkUpload.destructiveConfirm.lotsToDelete' | translate }}
      </div>
      <div class="metric__value" data-testid="destructive-lots-count">{{ data.lotsToDelete }}</div>
    </div>
    <div class="metric">
      <div class="metric__label">
        {{ 'pages.stock.bulkUpload.destructiveConfirm.unitsToDelete' | translate }}
      </div>
      <div class="metric__value" data-testid="destructive-units-count">{{ data.unitsToDelete }}</div>
    </div>
    <div class="metric">
      <div class="metric__label">
        {{ 'pages.stock.bulkUpload.destructiveConfirm.store' | translate }}
      </div>
      <div class="metric__value" data-testid="destructive-store-name">{{ data.storeName }}</div>
    </div>
  </div>

  <p class="destructive__warning">
    {{ 'pages.stock.bulkUpload.destructiveConfirm.cannotRevert' | translate }}
  </p>

  <form [formGroup]="form" class="destructive__form">
    <label for="destructive-typed" class="destructive__label">
      {{ 'pages.stock.bulkUpload.destructiveConfirm.typePrompt' | translate: { word: data.confirmWord } }}
    </label>
    <input id="destructive-typed" type="text" formControlName="typed"
      class="destructive__input" autocomplete="off"
      [attr.placeholder]="data.confirmWord"
      data-testid="destructive-confirm-input" />
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-testid="destructive-cancel" (click)="cancel()">
    {{ 'common.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-destructive" data-testid="destructive-confirm"
    [disabled]="!canConfirm" (click)="confirm()">
    {{ 'pages.stock.bulkUpload.destructiveConfirm.confirmButton' | translate }}
  </button>
</div>
